import React from "react";
import { motion } from "framer-motion";
import { Briefcase, BadgeCheck, Wrench, UserCheck, Compass } from "lucide-react";

const FEATURES = [
  { icon: Briefcase, title: "Industry Training", desc: "Curriculum built with active engineers & marketers." },
  { icon: BadgeCheck, title: "Verified Certificates", desc: "Every certificate is QR-verifiable, forgery-proof." },
  { icon: Wrench, title: "Practical Learning", desc: "Build 20+ real projects across every track." },
  { icon: UserCheck, title: "Expert Teachers", desc: "Mentors from product, design & AI companies." },
  { icon: Compass, title: "Career Guidance", desc: "1-on-1 placement, freelancing & startup support." },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative border-b border-white/5 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <p className="font-mono text-xs uppercase tracking-widest text-neon-green">/ about gitsi</p>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
              A modern institute built for the <span className="text-neon-green">AI generation</span>.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-white/70">
              GITSI is a digital skills & technology training institute focused on
              practical learning, career development, freelancing, startup culture,
              and industry-ready education. Our mission is to make world-class tech
              education accessible — and our vision is a future where every student
              ships real products.
            </p>

            <div className="mt-6 rounded-xl border border-neon-green/20 bg-black/40 p-4 font-mono text-sm">
              <p className="text-white/50">// mission</p>
              <p className="text-neon-green">empower(students) → builders;</p>
              <p className="mt-2 text-white/50">// vision</p>
              <p className="text-neon-green">india.future = code;</p>
            </div>
          </motion.div>

          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
            {FEATURES.map((f, i) => (
              <motion.div
                key={f.title}
                data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="card-hover glass rounded-2xl border border-white/5 p-5"
              >
                <div className="grid h-10 w-10 place-items-center rounded-lg border border-neon-green/30 bg-neon-green/10 text-neon-green shadow-neon-sm">
                  <f.icon size={18} />
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold text-white">{f.title}</h3>
                <p className="mt-1.5 text-sm text-white/65">{f.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
